import { useCallback } from 'react'
import { createDynamicPath, createQueryString } from '~/app/utils/urlUtils'
import { getYaNative } from '@yanolja-rnd/ya-native'
import conf from '~/app/conf'
import useNavigateInternalUrl from '~/app/utils/navigateInternalUrl'
import { useRouter } from 'next/router'

export const useHandleOrderItemButtonClick = () => {
  const router = useRouter()
  const { navigateInternalUrl } = useNavigateInternalUrl()
  const handleOrderItemButtonClick = useCallback(params => {
    const { id, param, orderId, parentOrderId } = params
    if (id === 'cancel') {
      const url = `/order-cancel/${parentOrderId ?? orderId}?categoryOrderId=${
        param.categoryOrderId
      }&initialCancelItemId=${param.id}`
      navigateInternalUrl(url)
    } else if (id === 'self-checkin' || id === 'check-ticket' || id === 'check-bus-tickets') {
      // 셀프 체크인 및 탑승권 확인 팝업 열기
      const path = createDynamicPath([orderId, id, param.id])
      const url = `/order-list/details/${path}`
      void router.push(url, undefined)
    } else if (id === 'information') {
      // 이용정보 팝업 열기
      const {
        categoryOrderId,
        type,
        propertyId,
        roomTypeId,
        checkIn,
        checkOut,
        dealId,
        optionId,
        propertyVersion,
        roomTypeVersion,
        cancelPolicyId,
        transportationCompanyCode,
      } = param
      const urlData =
        type === 'domestic'
          ? {
              path: createDynamicPath([propertyId, propertyVersion, roomTypeId, roomTypeVersion]),
              queryString: createQueryString({
                checkIn: encodeURIComponent(checkIn),
                checkOut: encodeURIComponent(checkOut),
                cancel: cancelPolicyId,
                categoryOrderId,
              }),
            }
          : type === 'leisure'
            ? {
                path: createDynamicPath([dealId, optionId]),
                queryString: createQueryString({ categoryOrderId }),
              }
            : type === 'bus'
              ? {
                  path: createDynamicPath([transportationCompanyCode]),
                  queryString: createQueryString({ categoryOrderId }),
                }
              : {
                  path: createDynamicPath([]),
                  queryString: createQueryString({ categoryOrderId }),
                }

      const url = `/order-list/details/${orderId}/${id}-${type}/${urlData.path}?${urlData.queryString}`
      void router.push(url, undefined)
    } else if (id === 'review') {
      // 리뷰 작성 이동하기
      const yaNative = getYaNative()
      const url = `${conf.web.url}/reviews/new/${param.target}?categoryOrderId=${
        param.id
      }&from=${encodeURIComponent(window.location.href)}`
      if (yaNative?.isEnabled) {
        yaNative.wv({
          method: 'get',
          url,
        })
      } else {
        window.location.href = url
      }
    } else if (id === 'voucher') {
      const { encrypted } = param
      const yaNative = getYaNative()
      const url = `${conf.leisure.url}/leisure-ticket?encrypted=${encodeURIComponent(encrypted)}`
      if (yaNative?.isEnabled) {
        yaNative.wv({
          method: 'get',
          url,
        })
      } else {
        window.location.href = url
      }
    } else if (id === 'nol-chat') {
      const yaNative = getYaNative()
      const url = `${conf.dmTalk.url}/chat/invitations/nol-domestic-stay-booking/${param.reservationId}`
      if (yaNative?.isEnabled) {
        yaNative.wv({
          method: 'get',
          url,
        })
      } else {
        window.location.href = url
      }
    }
  }, [])

  return { handleOrderItemButtonClick }
}

export default useHandleOrderItemButtonClick
